import { create } from 'zustand';

export type UsersStore = {
  searchString: string;
  page: number;
  rowsPerPage: number;

  setSearchString: (str: string) => void;
  setPage: (page: number) => void;
  setRowsPerPage: (size: number) => void;
  resetPagination: () => void;
};

const defaultValue = {
  searchString: '',
  page: 1,
  rowsPerPage: 10,
};

export const usersStore = create<UsersStore>((set) => ({
  ...defaultValue,

  setSearchString: (str: string) => set({ searchString: str, page: 1 }),
  setPage: (page: number) => set({ page }),
  setRowsPerPage: (rowsPerPage: number) => set({ rowsPerPage }),
  resetPagination: () => set({ page: 1, rowsPerPage: 10 }),
}));
